import React from 'react';
import PropTypes from 'prop-types';

import HorizontalSelectRadioField from 'components/new_ui/Form/HorizontalSelectRadioField';
import HorizontalSelectCheckboxField from 'components/new_ui/Form/HorizontalSelectCheckboxField';

export default function ChooseCalendars({ calendarType, calendars }) {
  return (
    <div className="mt-4">
      <p>Select Calendars to synchronize and block your availability</p>
      <HorizontalSelectCheckboxField
        name={calendarType === 'google' ? 'googleCalendars' : 'outlookCalendars'}
        containerClassName="row container-fluid"
        optionClassName="col-md-6"
        collection={calendars.map((calendar) => (
          { value: calendar.id, label: calendar.title }
        ))}
      />
      <p>Which calendar would you like us to send your new sessions?</p>
      <HorizontalSelectRadioField
        name={calendarType === 'google' ? 'googleCalendarId' : 'outlookCalendarId'}
        containerClassName="row container-fluid"
        optionClassName="col-md-6"
        collection={calendars.filter((item) => item.is_enable_choose).map((calendar) => (
          { value: calendar.id, label: calendar.title }
        ))}
      />
    </div>
  );
}

ChooseCalendars.propTypes = {
  calendarType: PropTypes.string.isRequired,
  calendars: PropTypes.arrayOf(PropTypes.object).isRequired,
};
